import React from 'react';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';

import { Icon, Title, Space, TitleDropdown } from 'components';

interface PageHeaderProps {
  navigateBack: () => void;
}

const PageHeader = ({ navigateBack }: PageHeaderProps) => {
  const { md } = useBreakpoint();

  return (
    <StyledPageHeader $md={md}>
      <Space wrap>
        <button onClick={navigateBack} data-cy="navigateBack-button">
          <Icon type="arrowLeftThin" color="black" offset={[0, 2]} />
        </button>

        <TitleDropdown type="team-settings" itemTitleLevel={3} />
      </Space>
    </StyledPageHeader>
  );
};

export default PageHeader;

const StyledPageHeader = styled.div<{ $md: boolean }>`
  display: grid;
  grid-template-columns: ${({ $md }) => ($md ? 'auto 1fr' : '1fr')};
  grid-gap: 12px;
  align-items: center;
  margin-top: 10px;
  width: 100%;
  & > *:last-child {
    display: flex;
    align-items: center;
  }
`;
